export default __webpack_public_path__ + "static/vmware-324bb8ac5ac739c40065fcbf2f1f4f0b.svg";